<template>
    <!-- 被保人填寫資料重複區域 -->
    <div id="confirmDetail">
        <ul class="confirmList">
            <li><span>身分證/居留證：</span><span class="tlf_n_l5 clarity-mask" id="assuredIdNo">{{ insure.insureIdNo }}</span></li>
            <li><span>姓名：</span><span class="tlf_r_f1 clarity-mask wordBreakAll" id="assuredName">{{ insure.insureName }}</span></li>
            <li><span>出生日期：</span><span class="tlf_n_dash1 clarity-mask" id="assuredBirth">{{ insure.insureBirthday }}</span></li>
            <li><span>保費：</span><span class="clarity-unmask">{{ formatMoney(insure.rosterTotalPremium) }}</span></li>
            <li><span>職/行業別：</span><span class="clarity-mask">{{ insure.insureJob }}</span></li>
            <li><span>身故受益人：</span><span class="clarity-unmask wordBreakAll">{{ insure.beneficiaryType }}</span></li>
        </ul>
        <div class="assureContent clarity-unmask">
            <ul>
                <li class="assureConTitle">
                    <p>保障內容</p>
                    <p>保額</p>
                </li>
                <div class="line"></div>
                <li>
                    <p>身故及失能或喪葬費用</p>
                    <p>{{ formatMoney(filterPrice(insure.travelAmount)) }}萬</p>
                </li>
                <li>
                    <p>傷害醫療</p>
                    <p>{{ filterPrice(insure.harmMedicalAmount) }}</p>
                </li>
                <li>
                    <p>個人賠償(每一事故自負額2,500元)</p>
                    <p>體傷20萬 / 財損10萬 / 保期內最高60萬</p>
                </li>
            </ul>

            <div class="showPlan" @click="clickShowPlan" :class="{ 'active': showPlan }"><p><span v-if="!showPlan">顯示</span><span v-if="showPlan">隱藏</span>詳細保障項目</p></div>
            <div class="" v-show="showPlan">
                <div class="line"></div>
                <ul v-if="mainPlan.isCheck" class="planUl">
                    <li class="planTitle">{{ mainPlan.plan_title }}</li>
                    <li v-for="(planItem, index) in mainPlan.plan_content" :key="index">
                        <p>{{ planItem.listItem }}</p>
                        <p>{{ planItem.listPrice }}</p>
<!--                        <p v-if="planItem.listPrice === ''">{{ planCodeStr }}</p>-->
<!--                        <p v-if="planItem.listPrice !== ''">{{ planItem.listPrice }}</p>-->
                    </li>
                </ul>
                <ul v-for="(item, index) in plan" v-show="item.isCheck" class="planUl" :key="index">
                    <li class="planTitle">{{item.plan_title}}</li>
                    <li v-for="(planItem, index) in item.plan_content" :key="index">
                        <p>{{ planItem.listItem }}</p>
                        <p>{{ filterPrice(planItem.listPrice)}}</p>
                    </li>
                </ul>
            </div>

        </div>
        <div class="attentionBox clarity-mask" v-if="insure.attention != null">
            <ul>
                <li v-html="insure.attention"></li>
            </ul>
        </div>
    </div>
</template>
<script setup>
        import {ref, watch} from "vue";


        const props = defineProps({
            insure: Object,
        })


        const pageStorage = JSON.parse(sessionStorage.getItem("pageStorage"));

        const mainPlan = ref(pageStorage.mainPlan);
        const plan = ref(pageStorage.plan);
        const showPlan = ref(false);
        //const planCodeStr = ref("");

        const clickShowPlan = () =>{
            showPlan.value = !showPlan.value;
        }
        //國內旅平各項規則
        const loadPlanCheck = () =>{
            mainPlan.value.isCheck = props.insure.buyUneasyPolicy;
            plan.value.forEach((planItem) => {
                switch(planItem.planName){
                    case "buyCarPolicy":
                        planItem.isCheck = props.insure.buyCarPolicy;
                        break;
                    case "buyMotorPolicy":
                        planItem.isCheck = props.insure.buyMotorPolicy;
                        break;
                    case "buyTriathlon":
                        planItem.isCheck = props.insure.buyTriathlon;
                        break;
                    case "buyTrafficAccident":
                        planItem.isCheck = props.insure.buyTrafficAccident;
                        break;
                }
            })
        }
        const filterPrice = (price) =>{ //過濾價錢格式
            if(price>=10000){
                return price/10000 + "萬"
            }else{
                return price.toLocaleString();
            }
        }
        // 總保費加上千分位號","
        const formatMoney = (value) => {
            if (value === null || value === undefined) return null;
            return parseFloat(value).toLocaleString("zh-TW", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 50,
            });
        };
    //  const getPlanCodeStr = () =>{
    //     switch(props.insure.planCode){
    //         case "I03": this.planCodeStr = "定額6,000"; break;
    //         case "I04": this.planCodeStr = "定額12,000"; break;
    //         case "I05": this.planCodeStr = "限額30,000"; break;
    //         case "I06": this.planCodeStr = "限額50,000"; break;
    //     }
    // },

        //getPlanCodeStr();
        loadPlanCheck();

        watch(()=>props.insure, ()=>{//載入時有更動資料的話重新載入，不寫這段plan會因為載入時間差沒有載入到
            //getPlanCodeStr();
            loadPlanCheck();
        })

</script>

<style lang="scss">
#confirmDetail {
    .assureContent {
        margin: 30px 0;

        ul {
            display: block;
          &.planUl{margin-bottom:5px;}
            li {
                display: flex;
                justify-content: space-between;
                line-height: 40px;
                width: 100%;

                @media screen and (max-width: $small) {
                    font-size:15px;
                    margin:15px 0;
                    p:first-child{
                        width: 58%;
                        text-align: left;
                        line-height: 20px;
                    }
                    p:last-child{
                        width: 40%;
                        line-height: 20px;
                        text-align: right;
                    }
                }

                &.assureConTitle {
                    p {
                        font-weight: bold
                    }

                }

            }
        }
    }
  .showPlan{text-align: center;padding-bottom:10px;margin-bottom:10px;
    p{display:inline-block;
      color:$blue-700;
      font-weight:500;
      position: relative;
      padding-right:20px;
      cursor:pointer;
      &:after{
        content:"";
        width:16px;
        height:16px;
        background-image: url("../../assets/arrow.png");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: bottom;
        position: absolute;
        right:0;
      }
    }
    &.active{
      p:after{
        transform: rotate(180deg);
        background-position:top;
      }
    }
  }
  .planTitle{
    font-size:19px;
    font-weight:bold;
  }
  .line{
    border:0;
    background:$gray;
    height:1px;
    margin:5px 0;
    &:before,&:after{
      width:5px;
      height:5px;
      border-radius: 5px;
      margin-top:-2px;
    }
  }
}

.wordBreakAll{
    word-break: break-all;
}
</style>